import { __decorate } from "tslib";
import { Action, Getter, Mutation, State } from "@/types";
import { service } from "@/services";
export class SystemEventsLevelsModule {
    constructor() {
        this.systemEventsLevels = [];
        this.count = 0;
        this.axiosError = null;
    }
    setItems(systemEventsLevels) {
        this.systemEventsLevels = systemEventsLevels;
    }
    setTotal(count) {
        this.count = count;
    }
    setError(error) {
        this.axiosError = error;
    }
    get list() {
        return this.systemEventsLevels;
    }
    get total() {
        return this.count;
    }
    get errorList() {
        return this.axiosError;
    }
    async get(options) {
        try {
            const data = await service.systemEventsLevels.get(options);
            this.setItems(data.items);
            this.setTotal(data.total);
        }
        catch (error) {
            this.setError(error);
            // push into Notice
            // server text error - "error.response.data.message"
            // or default error - "error.response.statusText"
            // or custom error message
            // or return Promise.reject(error)
        }
    }
}
__decorate([
    State()
], SystemEventsLevelsModule.prototype, "systemEventsLevels", void 0);
__decorate([
    State()
], SystemEventsLevelsModule.prototype, "count", void 0);
__decorate([
    State()
], SystemEventsLevelsModule.prototype, "axiosError", void 0);
__decorate([
    Mutation()
], SystemEventsLevelsModule.prototype, "setItems", null);
__decorate([
    Mutation()
], SystemEventsLevelsModule.prototype, "setTotal", null);
__decorate([
    Mutation()
], SystemEventsLevelsModule.prototype, "setError", null);
__decorate([
    Getter()
], SystemEventsLevelsModule.prototype, "list", null);
__decorate([
    Getter()
], SystemEventsLevelsModule.prototype, "total", null);
__decorate([
    Getter()
], SystemEventsLevelsModule.prototype, "errorList", null);
__decorate([
    Action()
], SystemEventsLevelsModule.prototype, "get", null);
